interface OrDividerProps {
  isMobile: boolean;
}
const OrDivider: React.FC<OrDividerProps> = ({ isMobile }) => {
  return (
    <div
      className={
        (isMobile ? "px-10 " : "") + "w-full flex items-center my-1 max-w-xs"
      }
    >
      <hr className="flex-grow border-t border-gray-300" />
      <span className="mx-4 text-gray-500">OR</span>
      <hr className="flex-grow border-t border-gray-300" />
    </div>
  );
};
export default OrDivider;
